<template src="./ModalDeliveryProductListComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {ref, watch, computed} from "vue";
import LabelPriority from "@/components/labels/label-priority/LabelPriority.vue";
import LabelStatus from "@/components/labels/label-status/LabelStatus.vue";
import IconEye from "@/components/icons/IconEye.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import InputTextareaNormal from "@/components/inputs/input-textarea/normal/InputTextareaNormal.vue";
import IconEdit from "@/components/icons/IconEdit.vue";
import IconTrash from "@/components/icons/IconTrash.vue";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import {AppConstant} from "@/supports/app.constant";
import {useProductStore} from "@/stores/product.js";
import {useAccountStore} from "@/stores/account.js";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import CommonService from "@/services/common.service";
export default {
  name: 'ModalDeliveryProductListComponent',
  components: {
    PaginateComponent,
    InputCheckboxOne,
    IconTrash, IconEdit,
    InputTextareaNormal,
    ButtonAddComponent,
    IconEye,
    LabelStatus,
    LabelPriority, ButtonSearchComponent, SelectNormal, InputTextNormal, BreadcrumbComponent, IconHome,
  },
  props: {
    showModalProduct: {
      type: Boolean,
      required: false,
      default: () => false
    },
    eventClickShowModal: {
      type: Boolean,
      required: false,
      default: () => false
    },
    listProductsSelected: {
      type: Array,
      required: false,
      default: () => []
    },
    typeSelectItem: {
      type: String,
      required: false,
      default: () => 'multiple'
    },
  },
  emits: ['showModalProduct', 'searchProduct', 'listProductsSelectedCurrent'],
  setup(props, { emit }) {
    const dataHeaderTable = ref({
      product_name: {
        label: 'Tên sản phẩm',
        order: 1,
        width: '15%',
      },
      product_code: {
        label: 'Mã sản phẩm',
        order: 2,
        width: '10%',
      },
      product_price: {
        label: 'Giá sản phẩm',
        order: 3,
        width: '10%',
      },
      product_selling_price: {
        label: 'Giá bán sản phẩm',
        order: 4,
        width: '10%',
      },
      product_tax: {
        label: 'Thuế',
        order: 5,
        width: '5%',
      },
      product_quantity: {
        label: 'Số lượng',
        order: 6,
        width: '10%',
      },
      product_status: {
        label: 'Tình trạng',
        order: 7,
        width: '10%',
      },
      product_unit: {
        label: 'Loại',
        order: 8,
        width: '10%',
      },
    })
    const dataSearch = ref({
      product_name: {
        id: 'product_name',
        label: 'Tên sản phẩm',
        placeholder: 'Tên sản phẩm',
        value: '',
        required: false
      },
      product_code: {
        id: 'product_code',
        label: 'Mã sản phẩm',
        placeholder: 'Mã sản phẩm',
        value: '',
        required: false
      },
      product_unit: {
        id: 'product_unit',
        label: 'Đơn vị sản phẩm',
        placeholder: 'Đơn vị sản phẩm',
        value: '',
        required: false
      },
      product_tax: {
        id: 'product_tax',
        label: 'Thuế',
        placeholder: 'Thuế',
        value: '',
        required: false
      },
    })
    const listProductCurrent = ref([])
    const listChecked = ref({})
    const listProductsSelectedCurrent = ref([])
    const labelButtonSearch = ref('Tìm kiếm')
    const urlOrigin = ref('/product/list/')
    const clickShowModal = ref(false)
    const productStore = useProductStore()
    const accountStore = useAccountStore()

    // bind list product when call api get list
    watch(() => productStore.products, (newListProduct) => {
      listProductCurrent.value = newListProduct
      listProductCurrent.value.forEach((product) => {
        product.product_status = 'Còn hàng';
        if(parseInt(product.product_quantity) === 0) {
          product.product_status = 'Hết hàng';
        }
      })
    });

    // bind list product selected when show modal
    watch(() => props.listProductsSelected, (newListProductSelected) => {
      listChecked.value = [];
      listProductsSelectedCurrent.value = [];
      newListProductSelected.forEach((item) => {
        listChecked.value[item.id] = true
        listProductsSelectedCurrent.value.push(item.id)
      })
    });

    // bind event click show modal to call api get list product
    watch(() => props.eventClickShowModal, (eventClickShowModal) => {
      listProductCurrent.value = productStore.products.map(product => JSON.parse(JSON.stringify(product)))
      clickShowModal.value = eventClickShowModal
      if(clickShowModal.value && (productStore.products.length === 0 || (productStore.products.length > 0 && productStore.lastPage !== 1)) ) {
        getListProduct(1)
        emit('showModalProduct', true)
      }
      if(productStore.products.length > 0 && productStore.lastPage === 1) {
        listChecked.value = [];
        listProductsSelectedCurrent.value.forEach((id) => {
          listChecked.value[id] = true
        })
        emit('showModalProduct', true)
      }
    })

    // call api get list product
    async function getListProduct(page, event) {
      const params = {
        id: accountStore.account.company.id,
        product_name: dataSearch.value.product_name.value,
        product_code: dataSearch.value.product_code.value,
        product_unit: dataSearch.value.product_unit.value,
        product_tax: dataSearch.value.product_tax.value,
        page: page,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/product/product-list';
      await productStore.getListProducts(url, params);
      if(event === 'search') {
        setTimeout(function () {
          emit('searchProduct', false)
        }, 500)
      }
    }

    // search product
    function searchProducts() {
      emit('searchProduct', true)
      getListProduct(1, 'search');
    }

    // event change input search
    function onChange(value, name) {
      dataSearch.value[name].value = value;
    }

    // listen change by paginate
    const paginate = computed(() => {
      return productStore.paginate;
    });
    // emit page from paginate component
    function emitPage(page) {
      getListProduct(page);
    }
    // submit modal to get product selected
    function applyProductSelected() {
      const listProduct = [];
      listProductsSelectedCurrent.value.forEach((id) => {
        const productCheck = listProductCurrent.value.find((item) => item.id === id);
        if(productCheck) {
          listProduct.push(productCheck);
        }
      })

      emit('listProductsSelectedCurrent', listProduct)
      emit('showModalProduct', false)
    }

    // event change by checkbox
    function onChangeSelectProduct(value, productId) {
      listChecked.value[productId] = value
      if(props.typeSelectItem === 'single') {
        listChecked.value.forEach((itemCheck, key) => {
          if(key !== productId) {
            delete listChecked.value[key]
          }
        })
        listProductsSelectedCurrent.value = [];
        listProductsSelectedCurrent.value.push(productId)
      }
      if(props.typeSelectItem === 'multiple') {
        listProductCurrent.value.forEach((product) => {
          if(value && listProductsSelectedCurrent.value.indexOf(product.id) === -1 && parseInt(productId) === parseInt(product.id)) {
            listProductsSelectedCurrent.value.push(product.id)
          }else if (!value && listProductsSelectedCurrent.value.indexOf(product.id) !== -1 && parseInt(productId) === parseInt(product.id)) {
            listProductsSelectedCurrent.value.splice(listProductsSelectedCurrent.value.indexOf(product.id), 1);
          }
        })
      }

    }

    return {
      dataHeaderTable,
      listProductCurrent,
      listProductsSelectedCurrent,
      dataSearch,
      labelButtonSearch,
      paginate,
      urlOrigin,
      listChecked,
      searchProducts,
      onChange,
      onChangeSelectProduct,
      emitPage,
      applyProductSelected,
      CommonService
    }
  },
}
</script>
<style lang="scss">
#modaldeliveryProduct {
  .modal-content {
    background: #ffffff;
  }
  .modal-header {
    border-bottom: 1px solid #d9dee3;
  }
}
@media (min-width: 1200px) {
  .modal-xxl {
    max-width: 1540px;
  }
}
</style>
